import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Root } from "./app/Root";
import { AuthProvider } from "./auth/AuthProvider";
import { I18nProvider } from "./i18n/I18nProvider";
import { AppConfigProvider } from "./state/AppConfigProvider";
import { AppFeedbackHost } from "./components/AppFeedback";
import "./styles/global.css";
import "./styles/corporate.css";
import "./styles/compact.css";
import "./styles/regressionFixes.css";
import { PlanProvider } from "./billing/PlanProvider";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <AppConfigProvider>
        <AuthProvider>
          <PlanProvider>
            <AppFeedbackHost />
            <Root />
          </PlanProvider>
        </AuthProvider>
      </AppConfigProvider>
    </I18nProvider>
  </StrictMode>
);
